import axios from 'axios';
import {useMutation} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

import {onChangeCartItemRes} from './helper';
import {useSetRecoilState} from 'recoil';
import {cartAtom} from 'store';

const changeCartItem = async (params: {
  id?: number;
  data: ChangeCartItemReqT;
}) =>
  axios.post(
    Routes.PRODUCT_PREFIX + '/' + params?.id + '/' + Routes.CHANGE_CART_ITEM,
    {
      ...params.data,
    },
  );

export const useChangeCartItem = () => {
  const setCart = useSetRecoilState(cartAtom);

  return useMutation({
    mutationKey: [Keys.CHANGE_CART_ITEM_MUT],
    mutationFn: changeCartItem,
    onSuccess: res => onChangeCartItemRes({cart: res.data.cart, setCart}),
  });
};
